import React, { Component } from "react";
import Lottie from 'react-lottie';

import Animation from "./animation/Gif_006.json"
import "./style.scss";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: Animation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

export class DepositSolution extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  doneClicked =()=>{

    let rowMap = {
      "Control 1 (homozygous normal Positive Control)": "Control 1 Thermocycler",
      "Control 2 (homozygous mutated Positive Control)": "Control 2 Thermocycler",
      "Control 3 (no template Negative Control)": "Control 3 Thermocycler",
      "Control 4 (prokaryotic control DNA Negative Control)": "Control 4 Thermocycler",
      "Control 1 (Positive Control)": "Control 1 Thermocycler",
      "Control 2 (Positive Control)": "Control 2 Thermocycler",
      "Control 3 (Negative Control)": "Control 3 Thermocycler",
      "Control 4 (DNA Negative Control)": "Control 4 Thermocycler"
    }

    this.props.tableData.data.forEach((row, rowIndex)=>{
      if(rowIndex !== 0){

        let itemProps = this.props.solutions.find((solution) => solution.type === rowMap[row[0]]);
        let solutions = [];


        // Set the template DNA based off the Protocol Table
        if(row[1] !== null && row[2] !== null){
          solutions.push({
            [row[2]]:parseFloat(row[1], 10)
          })
        }

        // Set the Master Mix volume
        if(row[3] !== null){

          let solutionsArr = Object.keys(this.props.solutions[6].solutions);
          let totalVol = this.props.solutions[6].volume;

          // Master Mix is ID 7
          solutionsArr.forEach((solution, index)=>{

            let solutionVolume = this.props.solutions[6].solutions[solution];

            solutions.push({
              [solution]: (row[3] * (solutionVolume / totalVol))
            })
          })
        }

        // Set the dH20 volume
        if(row[4] !== null){
          solutions.push({
            "DNase Free Water": parseFloat(row[4], 10)
          })
        }

        if(typeof itemProps !== 'undefined' && Object.keys(solutions).length > 0){
          this.props.incSolution({
            id: itemProps.id,
            solutions: solutions,
            fragments: {},
          })
        }
      }
    })

    // this.props.decSolution({
    //   id: solutionID,
    //   type: solutionObj.type,
    //   amount: volume
    // });

    this.props.showModal({
      display: false
    })
  }

  render() {

    return (
      <div className="modal-section deposit-solution" style={{ width: "calc(100% - 0px)", height: "650px", margin: "auto" }}>
        <div className="modal-header">
          <h2>Pipette Samples</h2>
        </div>

        <div className="modal-body">
          <div className="modal-inner">
            <Lottie
              options={defaultOptions}
              width={"auto"}
              height={"100%"}
              isStopped={this.state.isStopped}
              isPaused={this.state.isPaused} />
          </div>
        </div>

        <div className="modal-footer">

          <button
            aria-label="Done"
            tabIndex={this.props.tab}
            className="modal-btn-primary"
            onClick={()=>this.doneClicked()}>
              Done
          </button>

        </div>

      </div>

    );
  }
}
